import {Component, Inject} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {IIMetadataItemOptionsDto} from '../../../../../pages/settings/documentfields/metadata-item.dto';
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from '../../../applied-filters-updater';
import {AbstractFilterComponent} from '../../abstract-filter.component';
import {AdvancedFilterOperatorEnum, AdvanceFilterParamType} from '../../advance-filter';

@Component({
    selector: 'app-droplist-filter',
    templateUrl: './droplist-filter.component.html',
    styleUrl: './droplist-filter.component.scss'
})
export class DroplistFilterComponent extends AbstractFilterComponent<{availableOperators: AdvancedFilterOperatorEnum[], items:[] }> {

    get availableOperators(): AdvancedFilterOperatorEnum[] {
      return this.options?.availableOperators || [AdvancedFilterOperatorEnum.ne, AdvancedFilterOperatorEnum.eq];
    }

    constructor(@Inject(IAppliedFiltersUpdaterToken) filterUpdater: IAppliedFiltersUpdater<AdvanceFilterParamType>,
                _formBuilder: FormBuilder) {
        super(_formBuilder, filterUpdater);
    }

    get ddlItems(): IIMetadataItemOptionsDto[] {
        return this.options?.items || [];
    }

}
